export default {
  // 各个端token存放地
  token: {
    drug: {
      tokenKey: 'token_drug',
      refreshKey: 'refresh_drug',
      corpKey: 'drug_corp',
    },
    service: {
      tokenKey: 'token_service',
      refreshKey: 'refresh_service',
      corpKey: 'service_corp',
      operateKey: 'service_operate',
    },
    admin: {
      tokenKey: 'token_admin',
      refreshKey: 'refresh_admin',
    },
  },

  defaultImg: {
    DRUG_IMG: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1561000262089&di=d51c8221fc8632ce8d56734c395c0617&imgtype=0&src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fq_70%2Cc_zoom%2Cw_640%2Fimages%2F20180812%2F8ff178363b4e4cc7837251dff421dece.jpeg',
    MALE_IMG: '//platform-data.jundaodsj.com/FjC3N65z91lZ8R7IoReVnOQmxhXK',
    FEMALE_IMG: '//platform-data.jundaodsj.com/FjB3wEPQ7gARvqtquxSEzw8oNdtJ',
    CORP_IMG: '//platform-data.jundaodsj.com/FjUpK9vhN5QhGQe6IoKYYBuqBlgP',
    EMPTY_IMG: '//platform-data.jundaodsj.com/FhnXWi7wtoY38JAWm1nIzN_UEUVl',
  },

  // 七牛云base64上传文件url
  qiniuBase64Url: '//upload-z2.qiniup.com/putb64/-1',
  qiniuUrl: '//upload-z2.qiniup.com',

  // 字典表key
  dictKey: {
    department: '03',
    serviceType: '05',
    activityType: '07',
    activity: '08',
    channel: '11',
    post: '13',
    title: '14',
    questionType: '15',
    corpScale: '16',
    picType: '18',
  },

  // 表格单元格的类型
  columnType: {
    IMG: 1,
    FILE: 2,
    PREVIEW: 3,
    LINK: 4,
    BTN: 5,
  },

  // 合作公司签约状态
  signStats: {
    all: '',          // 全部
    unsigned: 0,      // 待签约
    signed: 1,        // 已签约
    reject: 2,        // 已拒绝
    terminated: 3,    // 已解约
  },

  // 招标状态
  bidStatus: {
    all: '',          // 全部
    toBeAudited: 0,   // 待审核
    bidding: 1,       // 投标中
    evaluation: 2,    // 评标中
    calibration: 3,   // 定标中
    over: 4,          // 已结束
    discard: 5,       // 已废弃(投标中/评标中/定标中状态可废弃)
  },
  bidAStatusArr: [
    {
      key: 0,
      value: '待审核',
    },
    {
      key: 1,
      value: '投标中',
    },
    {
      key: 2,
      value: '评标中',
    },
    {
      key: 3,
      value: '定标中',
    },
    {
      key: 4,
      value: '已结束',
    },
    {
      key: 5,
      value: '已废弃',
    },
  ],

  // 投标状态
  bidBStatus: {
    all: '',          // 全部
    toBeTender: 0,    // 待投标
    tendering: 1,     // 投标中
    evaluated: 2,     // 已评标
  },
  bidBStatusArr: [
    {
      key: 0,
      value: '待投标',
    },
    {
      key: 1,
      value: '投标中',
    },
    {
      key: 2,
      value: '已评标',
    },
  ],

  // 合同状态
  contractStatus: {
    all: '',          // 全部
    toBeAudited: 0,   // 待审核
    unsigned: 1,      // 待签约
    progress: 2,      // 进行中
    finished: 3,      // 已结束
    discard: 4,       // 已废弃(已签约进行中状态可废弃，前提是没有分解成任务)
  },
  contractStatusArr: [
    {
      key: 0,
      value: '待审核',
    },
    {
      key: 1,
      value: '待签约',
    },
    {
      key: 2,
      value: '进行中',
    },
    {
      key: 3,
      value: '已结束',
    },
    {
      key: 4,
      value: '已废弃',
    },
  ],

  // 任务状态
  taskStatus: {
    all: '',          // 全部
    toBeAudited: 0,   // 待审核
    audited: 1,       // 已审核-归集进行中
    submitted: 2,     // 已提交-待药企审批
    approved: 3,      // 已审批-结束
    discard: 4,       // 已废弃(已审核-归集进行中状态可废弃，前提是没有生成推广记录)】
  },
  taskStatusArr: [
    {
      key: 0,
      value: '待审核',
    },
    {
      key: 1,
      value: '已审核',
    },
    {
      key: 2,
      value: '已提交',
    },
    {
      key: 3,
      value: '已审批',
    },
    {
      key: 4,
      value: '已废弃',
    },
  ],

  checkStatusConst: {
    all: '',
    toBeAudited: 0,   // 待审核
    success: 1,          // 审核通过
    fail: 2,        // 审核不通过
  },

  // 公司类别
  corpClasses: [
    {
      key: 'YQ',
      value: 'YQ'
    },
    {
      key: 'FW',
      value: 'FW',
    },
  ],

  roleTypes: [
    {
      key: 0,
      value: '管理员'
    },
    {
      key: 1,
      value: '药企',
    },
    {
      key: 2,
      value: '服务商'
    },
  ],

  // 公司类型
  corpTypes: [
    {
      key: '一般纳税人',
      value: '一般纳税人'
    },
    {
      key: '小规模',
      value: '小规模',
    },
    {
      key: '个人独资',
      value: '个人独资'
    },
  ],

  // 认证状态
  certStatus: [
    {
      key: 0,
      value: '待认证'
    },
    {
      key: 1,
      value: '已认证',
    },
    {
      key: 2,
      value: '认证中'
    },
  ],

  // 公司状态
  corpStatuses: [
    {
      key: 0,
      value: '正常'
    },
    {
      key: 1,
      value: '冻结'
    },
    {
      key: 2,
      value: '注销'
    },
  ],

  // 医生级别
  doctorLevel: [
    {
      key: 1,
      value: '一级',
    },
    {
      key: 2,
      value: '二级',
    },
    {
      key: 3,
      value: '三级',
    },
    {
      key: 4,
      value: '四级',
    },
    {
      key: 5,
      value: '五级',
    },
    {
      key: 6,
      value: '六级',
    },
  ],

  // 性别
  sexes: [
    {
      key: false,
      value: '女'
    },
    {
      key: true,
      value: '男'
    },
  ],

  yesNo: [
    {
      key: false,
      value: '否'
    },
    {
      key: true,
      value: '是'
    },
  ],

  // 审核状态
  checkStatus: [
    {
      key: false,
      value: '未审核'
    },
    {
      key: true,
      value: '已审核'
    },
  ],
  checkStatus1: [
    {
      key: 0,
      value: '待审核'
    },
    {
      key: 1,
      value: '审核通过'
    },
    {
      key: 2,
      value: '审核不通过'
    },
  ],

  // 原研/仿制
  originalImitation: [
    {
      key: '原研',
      value: '原研'
    },
    {
      key: '仿制',
      value: '仿制'
    },
  ],

  // 处方药/OTC
  cfyOtc: [
    {
      key: '处方药',
      value: '处方药'
    },
    {
      key: 'OTC',
      value: 'OTC'
    },
  ],

  // 产品类型
  productType: [
    {
      key: 0,
      value: '药品',
    },
    {
      key: 1,
      value: '器械',
    }
  ],

  articleType: [
    {
      key: false,
      value: '上传PDF',
    },
    {
      key: true,
      value: '富文本编辑',
    },
  ],

  bidType: [
    {
      key: 0,
      value: '公示招标',
    },
    {
      key: 1,
      value: '邀请招标',
    },
  ],

  // 服务项目类型
  serviceType: [
    {
      key: '拜访管理',
      value: '拜访管理',
    },
    {
      key: '活动管理',
      value: '活动管理',
    },
    {
      key: '市场调研',
      value: '市场调研',
    },
    {
      key: '信息收集',
      value: '信息收集',
    },
    // {
    //   key: '市场开发',
    //   value: '市场开发',
    // },
  ],

  // 两票制是否解决
  twoVotes: [
    {
      key: false,
      value: '未解决',
    },
    {
      key: true,
      value: '已解决',
    },
  ],

  // 拜访客户类型
  visitType: [
    {
      key: 0,
      value: '临床',
    },
    {
      key: 1,
      value: '药店',
    },
    {
      key: 2,
      value: '渠道',
    }
  ],

  // 签约状态
  signStatus: [
    {
      key: 0,
      value: '待签约',
    },
    {
      key: 1,
      value: '已签约',
    },
    {
      key: 2,
      value: '已拒绝',
    },
    {
      key: 3,
      value: '已解约',
    }
  ],
}
